import React from 'react';
import { Typography, Grid } from '@mui/material';
import { CallBox, CallButton, CallHeader, CallStateActive } from './call-styles';
import { Phone } from '@mui/icons-material';
import { useCallSelector, usePhoneActions } from '../../hooks/use-phone';
import { useCallIdentity } from '../../hooks/use-call-identity';
import { formatUSPhoneNumber } from '../../utils/formatter';

export default function CallOutbound(props: { callId: string }) {
  const remoteIdentity = useCallSelector(props.callId, (x) => x.remoteIdentity);
  const { contactNames } = useCallIdentity({ phoneNumber: remoteIdentity as string });
  const { cancel } = usePhoneActions();

  return (
    <CallBox data-testid="call-outbound">
      <CallHeader>
        <Grid container>
          <Grid item xs={10} zeroMinWidth>
            <CallStateActive>OUTBOUND CALL</CallStateActive>
            <Typography variant="h6" noWrap>
              {contactNames ? contactNames : ''}
            </Typography>
            <Typography variant="body2">{formatUSPhoneNumber(remoteIdentity)}</Typography>
          </Grid>
          <Grid item xs={2} style={{ textAlign: 'right' }}>
            <CallButton
              onClick={() => cancel(props.callId)}
              sx={{ backgroundColor: 'rgb(244, 73, 72)', '&:hover': { backgroundColor: 'rgb(244, 73, 72)' } }}
            >
              <Phone sx={{ transform: 'rotate(135deg)' }}/>
            </CallButton>
          </Grid>
        </Grid>
      </CallHeader>
    </CallBox>
  );
}
